/**
 * Between one pill's entrance and the next, task chips included.
 *
 * Its own module so the task chips can read it without importing the pill
 * component, which carries ten brand-icon components with it.
 *
 * Web counts top-down from a fixed delay; native counts bottom-up from the
 * stack's size (`RisingPill.STAGGER_MS`). Deliberately not shared: the two
 * surfaces reveal in opposite directions at different speeds.
 */
export const PILL_STAGGER_MS = 40;
